<div class="search-component">
    <mat-form-field class="search" floatLabel='never'>
        <input [(ngModel)]="searchString" (keyup.enter)="generalSearch()" placeholder="Search" matInput>
        <button mat-button matSuffix mat-icon-button aria-label="Clear"
                *ngIf="this.searchObject && this.searchObject.searchString" (click)="resetGeneralSearch()">
            <mat-icon class="clear-button">close</mat-icon>
        </button>
        <button mat-button matPrefix mat-icon-button>
            <mat-icon class="search-button">search</mat-icon>
        </button>
    </mat-form-field>
    <div class="advanced-search" *ngIf="searchComponent">
        <div class="advanced-search-label" (click)="openAdvancedSearch()">Advanced Search</div>
        <div (click)="openAdvancedSearch()" class="advanced-search-description" matTooltip="{{searchDescription}}">{{searchDescription}}</div>
        <mat-icon (click)="clearAdvancedSearch()" *ngIf="searchDescription">close</mat-icon>
        <mat-icon (click)="openAdvancedSearch()">tune</mat-icon>
    </div>
</div>
